import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
var _excluded = ["to", "title", "linkAs", "contentProps", "internal"],
    _excluded2 = ["to", "title", "linkAs", "contentProps", "internal"];
import React from 'react';
import { ObjectPropsPropType } from '../../services/proptypes';
import InternalLink from '../InternalLink';
import OutboundLink from '../OutboundLink';
import LinkContent from './components/LinkContent';

var Link = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Link, _React$Component);

  function Link() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Link.prototype;

  _proto.renderExternalLink = function renderExternalLink() {
    var _this$props = this.props,
        to = _this$props.to,
        title = _this$props.title,
        linkAs = _this$props.linkAs,
        contentProps = _this$props.contentProps,
        internal = _this$props.internal,
        rest = _objectWithoutPropertiesLoose(_this$props, _excluded);

    return /*#__PURE__*/React.createElement(OutboundLink, _extends({
      label: title,
      to: to
    }, rest), /*#__PURE__*/React.createElement(LinkContent, _extends({
      linkAs: linkAs,
      title: title
    }, contentProps)));
  };

  _proto.renderInternalLink = function renderInternalLink() {
    var _this$props2 = this.props,
        to = _this$props2.to,
        title = _this$props2.title,
        linkAs = _this$props2.linkAs,
        contentProps = _this$props2.contentProps,
        internal = _this$props2.internal,
        rest = _objectWithoutPropertiesLoose(_this$props2, _excluded2);

    return /*#__PURE__*/React.createElement(InternalLink, _extends({
      to: to,
      label: title
    }, rest), /*#__PURE__*/React.createElement(LinkContent, _extends({
      linkAs: linkAs,
      title: title
    }, contentProps)));
  };

  _proto.render = function render() {
    var internal = this.props.internal;
    return internal ? this.renderInternalLink() : this.renderExternalLink();
  };

  return Link;
}(React.Component);

export { Link as default };
Link.defaultProps = {
  internal: true,
  linkAs: 'span',
  contentProps: {}
};